import vue from 'vue'
import Lockr from "lockr";
import {CourseList, TextbookList} from "@/api/teacher";
import {getSelectData} from "@/utils/form";
import dialog from './dialog'

// 组件构造器，构造出一个 vue组件实例
const DialogConstructor = vue.extend(dialog)

function CourseSelect({
                          data,
                          success
                      }) {
    const DialogDom = new DialogConstructor({
        el: document.createElement('div'),
        data() {
            return {
                student_id: data.student_id,
                visible: true,
                searchForm: {
                    curriculum_edition_id: "",
                    student_id: data.student_id
                },
                courseList: [],
                page: 1,
                limit: 10,
                tableData: [],
                currentPage: 1,
                totalCount: 0,
                tableField: [{
                    label: "课程",
                    prop: "name_text"
                },
                    {
                        label: "课本",
                        prop: "name"
                    }
                ],
                courseType: []
            };
        },
        methods: {
            // 关闭
            close() {
                this.visible = false;
                DialogDom.$el.remove()
            },
            async getCourseType() {
                let params = {
                    token: Lockr.get("teacherToken")
                };
                let result = await CourseList(params);
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    this.courseType = getSelectData(result.data, "name", "id");
                    this.refreshTable()
                } else {
                    this.$message({
                        message: result.msg,
                        type: "warning"
                    });
                }
            },
            // 课本列表
            async tableList() {
                let params = this.searchForm;
                params.token = Lockr.get("teacherToken");
                params.page = this.page;
                params.limit = this.limit;
                let result = await TextbookList(params);
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    let list = result.data;
                    let arr = [];
                    if (list && list.length > 0) {
                        arr = list.map(item => {
                            item.name_text = item.type == 1 ? '【单词】' + item.name : item.type == 2 ? '【语法】' : item.type == 3 ? "音标" : ''
                            return item;
                        });
                    }
                    this.tableData = arr;
                    this.totalCount = result.data.count;
                    this.currentPage = this.page;
                } else {
                    this.$message({
                        message: result.msg,
                        type: "warning"
                    });
                }
            },
            refreshTable() {
                this.page = 1;
                this.tableList();
            },
            handleClick(type, item) {
                if (type == "reset_password") {
                    this.resetPassword(item.student_id, item.realname);
                } else if (type == "setting") {
                    this.$router.push({
                        path: "studentIndex/studentInfo",
                        query: {
                            student_id: item.student_id
                        }
                    });
                }
            },
            handleSizeChange(value) {
                this.limit = value;
                this.tableList();
            },
            handleCurrentChange(value) {
                this.page = value;
                this.tableList();
            },
            handleSelected(item) {
                this.$confirm('你确定有选择此课程吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    success(item)
                    this.close()
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            }
        },
        created() {
            this.getCourseType()
        }
    })
    // 添加节点
    document.body.appendChild(DialogDom.$el)
}

export default CourseSelect